import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  Typography,
} from '@mui/material'
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material'
import { SplitButtonProps } from './DashboardToggle.types'
import { useTheme } from '@mui/material/styles'
import { useRef, useState } from 'react'

export const SplitButton = ({
  setSelectedButtonIndex,
  enabled,
  options,
  disabledOptions = [],
  handleSelectedOption,
  handleToggleButton,
}: SplitButtonProps) => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    if (!enabled) {
      handleToggleButton()
      setSelectedButtonIndex(0)
    }
    handleSelectedOption('dashboard')
  }

  const handleMenuItemClick = (index: number) => {
    if (!enabled) {
      handleToggleButton()
      setSelectedButtonIndex(0)
    }
    handleSelectedOption(options[index])
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <ButtonGroup
        sx={{
          borderRadius: 0,
        }}
        ref={anchorRef}
        aria-label="split button"
        variant={enabled ? 'contained' : 'outlined'}
      >
        <Button
          onClick={handleClick}
          variant={enabled ? 'contained' : 'outlined'}
          sx={{
            backgroundColor: enabled ? '#00415A !important' : '#fafafa',
            color: enabled ? '#FFF' : '#000',
            textTransform: 'none',
            borderRadius: 0,
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
            }}
            variant="button"
          >
            Dashboard
          </Typography>
        </Button>
        <Button
          variant={enabled ? 'contained' : 'outlined'}
          sx={{
            backgroundColor: enabled ? '#00415A !important' : '#fafafa',
            color: enabled ? '#FFF' : '#000',
            textTransform: 'none',
            borderRadius: 0,
          }}
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 10,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={disabledOptions.includes(option)}
                      onClick={() => handleMenuItemClick(index)}
                    >
                      <Typography
                        sx={{
                          fontWeight: 'bold',
                        }}
                        variant="button"
                      >
                        {option}
                      </Typography>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
